

































































































































































































































































































import { Vue, Component, Ref } from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import CompCheckBox from '@/components/common/CompCheckBoxButton.vue';
import editor from '@/components/common/summernote/Index.vue';
import {ncpPopup} from '@/utils/ncp';
import {namespace} from 'vuex-class';
import {Admin} from '@/types';
// import {popupResize} from '@/utils/ncp';

import {
  PostInquiriesInquiryNoAnswerRequest,
  GetInquiriesInquiryNoRequest,
  InquiriesInquiryNoHistoriy,
  InquiryAnswerTemplate,
  GetInquiryAnswerTemplatesRequest,
  InquiryAnswer,
  InquiriesType,
  Email,
  Sms,
  Issuer,
  Assignee,
  StorageResponse,
  PostStorageRequest,
  FileName,
  DeleteInquiriesInquiryNoFileRequest
} from 'supporter';
import {BYTE} from '@/const/unit';
import { convertProductUri } from '@/utils/commonUtils';

const possibleAttachmentExtensions = [
  'jpg',
  'jpeg',
  'png',
  'gif',
  'bmp',
  'pdf',
  'doc',
  'docx',
  'ico',
  'pptx',
  'xlsx',
  'xls',
]
const possibleAttachmentSize = 5;

const adminModule = namespace('admin');
@Component({
  components: {PageTitle, CompSelectBox, CompCheckBox, editor}
})
export default class InquiryDetailPopup extends Vue {
  @adminModule.Getter('admin') private admin!: Admin;

  private initOver = false;
  private hasAnswerNo = false;
  private inquiryNo: string = '';
  private mallNo: any = '';
  private sumcontent: string = '';

  private smsSend: string = '';
  private smsSendOption = {
    name: 'smsSendOption',
    hasAll: false,
    noBrackets: true,
    disabled: true,
    data: [
      {
        id: 'SMSSEND',
        value: 'SMSSEND',
        dispaly: 'INQUIRY_INQUIRY_DETAIL_TRANSMISSION'
      }
    ]
  };

  private emailSend: string = '';
  private emailSendOption = {
    name: 'emailSendOption',
    hasAll: false,
    noBrackets: true,
    disabled: true,
    data: [
      {
        id: 'EMAILSEND',
        value: 'EMAILSEND',
        dispaly: 'INQUIRY_INQUIRY_DETAIL_TRANSMISSION'
      }
    ]
  };

  private sms: Sms = {
    sendsNotification: false,
    mobileNo: '',
    sent: false
  };

  private email: Email = {
    sendsNotification: false,
    email: '',
    sent: false
  };

  private inquiryAnswer: InquiryAnswer = {
    answered: false,
    answerContent: '',
    answeredDateTime: '',
    sms: this.sms,
    email: this.email
  };

  private issuer: Issuer = {
    issuerId: '',
    issuerEmail: '',
    issuerStatus: '',
    issuerNo: 0,
    issuerTeamName: null,
  };

  private assignee: Assignee = {
    assigneeName: '',
    assigneeStatus: '',
    assigneeNo: 0
  };

  private inquiriesType: InquiriesType = {
    name: '',
    channel: '',
    no: 0
  };

  private inquiriesInquiryNo: any = {
    orderNo: '',
    answer: this.inquiryAnswer,
    delayed: false,
    status: '',
    issuer: this.issuer,
    title: '',
    type: this.inquiriesType,
    no: 0,
    issuedDateTime: '',
    files: [],
    content: '',
    assignee: this.assignee,
    mallNo: 0,
    productNo: 0
  };

  private editorData: any = {
    htmlContent: '',
    textContent: ''
  };

  private editorOptions = {
    width: 1500,
    class: 'note-editor note-frame panel panel-default'
  };

  private answerFileList: File[] = [];
  private answerFileNumberLimit = 10;

  @Ref()
  private editorRef:editor;

  private handleFileInputChange(e: Event) {
    const target = e.currentTarget as HTMLInputElement;
    const file = target.files?.[0];
    if (!file) return;
    target.value = null;

    if (this.answerFileList.length >= this.answerFileNumberLimit) {
      alert(this.$t('INQUIRY_INQUIRY_DETAIL_ATTACHMENT_NUMBER_ALERT_MSG', { limit: this.answerFileNumberLimit }));
      return;
    }

    if (!(file.size <= possibleAttachmentSize * BYTE.MB)) {
      alert(this.$t('INQUIRY_INQUIRY_DETAIL_ATTACHMENT_SIZE_ALERT_MSG', { size: possibleAttachmentSize + 'MB' }));
      return;
    }

    const extensionMatchingReg = new RegExp(`\\.(${possibleAttachmentExtensions.join('|')})$`, 'i');
    const isPossibleExtension = file.name.match(extensionMatchingReg);
    if (!isPossibleExtension) {
      alert(this.$t('INQUIRY_INQUIRY_DETAIL_ATTACHMENT_EXTENSION_ALERT_MSG' , { extensions: possibleAttachmentExtensions.join('/ .') }));
      return;
    }

    const isAlreadyStagedFileList = this.answerFileList.some(prevFile => file.name === prevFile.name);
    if (isAlreadyStagedFileList) {
      alert(this.$t('INQUIRY_INQUIRY_DETAIL_ATTACHMENT_SAME_NAME_ALERT_MSG'));
      return;
    }
    this.answerFileList = [...this.answerFileList, file];
  }


  private makePostStorageRequest(file: File, container: string = 'ncp', keyName: string = 'file'): PostStorageRequest {
    const formData = new FormData();
    formData.append(keyName, file as File);
    formData.append('container', container);

    return {
      data: formData,
    };
  };

  private async saveFilesToStorage(fileList: File[]): Promise<StorageResponse[]>{
      if (!fileList.length) {
        throw new Error('파일 없음');
      }
      return Promise.all(fileList.map(async file => (await this.$api.postStorage(this.makePostStorageRequest(file))).data));
  }

  private deleteFile(file: File) {
    this.answerFileList = this.answerFileList.filter(prevFile => file.name !== prevFile.name);
  }

  private async deleteUploadedFile(fileNameInfo: FileName, type: 'inquiry' | 'answer', container: string = 'ncp') {
    if (!confirm(this.$t('INQUIRY_INQUIRY_DETAIL_DELETE_ATTACHMENT_CONFIRM_MSG') as string)) return;

    const request: DeleteInquiriesInquiryNoFileRequest = {
      pathParams: {
        inquiryNo: this.inquiryNo
      },
      params: {
        fileName: fileNameInfo.uploadedFileName,
        mallNo: this.mallNo,
        container,
      }
    }
    const deleteFunc = type === 'inquiry' ? this.$api.deleteInquiriesInquiryNoFile : this.$api.deleteInquiriesInquiryNoAnswerFile;
    await deleteFunc(request);
    window.location.reload();
  }

  private editorOnChange({html, text}: {html: string; text: string}): void {
    Object.assign(this.editorData, {htmlContent: html, textContent: text});
  }

  get getInquiriesInquiryNoRequest(): GetInquiriesInquiryNoRequest {
    return {
      params: {
        inquiryNo: this.$route.params.inquiryNo
      }
    };
  }

  private async getInquiriesInquiryNo() {
    let res = await this.$api.getInquiriesInquiryNo(this.getInquiriesInquiryNoRequest);
    this.inquiriesInquiryNo = res.data;
  }

  private templates: InquiryAnswerTemplate[] = [];
  private templateNo: any = 0;
  private oldTemplateNo: any = 0;
  private async getInquiryTemplates() {
    const templateRequest: GetInquiryAnswerTemplatesRequest = {
      params: {
        // mallNo: Number(this.mallNo)
        mallNo: Number(this.inquiriesInquiryNo.mallNo)
      }
    };
    const result = await this.$api.getInquiryAnswerTemplates(templateRequest);
    this.templates = result.data;
  }

  public async getAnswerContent() {
    const answerRequest = {
      params: {
        inquiryNo: this.inquiryNo
      }
    };
    const result = await this.$api.getInquiriesInquiryNoAnswer(answerRequest);
    return result.data.answerContent;
  }

  private async onSave(key: boolean) {
    if (key) {
      if (!confirm(this.$t('INQUIRY_INQUIRY_DETAIL_CONFIRM_SEND').toString())) {
        return;
      }
    } else {
      if (!confirm(this.$t('INQUIRY_INQUIRY_DETAIL_CONFIRM_SAVE').toString())) {
        return;
      }
    }
    const answerContent = await this.getAnswerContent();
    if (answerContent && answerContent.length > 0) {
      if(key){
        if (!confirm(this.$t('INQUIRY_INQUIRY_DETAIL_CONFIRM_HAD_CONTENT').toString())) {
          return;
        }
      }else{
        alert(this.$t('INQUIRY_INQUIRY_DETAIL_WARN_SAVE'));
        this.hasAnswerNo = true;
        return;
      }
    }

    const fileNameList = this.answerFileList.length ? await this.saveFilesToStorage(this.answerFileList) : [];

    let request: PostInquiriesInquiryNoAnswerRequest = {
      params: {
        inquiryNo: this.inquiryNo
      },
      data: {
        mobileNo: this.inquiriesInquiryNo.answer ? this.inquiriesInquiryNo.answer.sms.mobileNo : '',
        completed: key,
        email: this.inquiriesInquiryNo.answer ? this.inquiriesInquiryNo.answer.email.email : '',
        content: this.editorRef.getHtml(),
        files: fileNameList,
      }
    };
    this.$api.postInquiriesInquiryNoAnswer(request).then(() => {
      if (key) {
        alert(this.$t('INQUIRY_INQUIRY_DETAIL_SUCCESS_SEND'));
        if (this.$route.query.callback) {
          $(window.opener.location).attr('href', `javascript:window.${this.$route.query.callback}();`);
        }
        window.close();
      } else {
        alert(this.$t('INQUIRY_INQUIRY_DETAIL_SUCCESS_SAVE'));
        location.reload();
      }

    });
  }

  private productDetailUrl = '';
  // private async getProductDetailUrl() {
  //   let request: any = {
  //     pathParams: {
  //       mallNo: this.$route.query.mallNo
  //     },
  //     params: {
  //       key: 'MALL_PRODUCT'
  //     }
  //   };
  //   let {data} = await this.$api.getMallsConfigurations(request);
  //   this.productDetailUrl = data.productDetailUrl.replace('${mallProductNo}', this.inquiriesInquiryNo.productNo);
  // }

  private async getProductDetailUrl() {
    let request: any = {
      params: {
        // mallNo: this.$route.query.mallNo
        mallNo: Number(this.inquiriesInquiryNo.mallNo)
      }
    };
    let {data} = await this.$api.getProductsConfiguration(request);
    this.productDetailUrl = convertProductUri(data.productDetailUrl, this.inquiriesInquiryNo.productNo?.toString());
  }

  private hasOrder = false;
  private ordererContact1 = '';
  private ordererContact2 = '';
  private lastPayAmt = 0;
  private lastDeliveryAmt = 0;
  private registerYmdt = '';
  private async getOrder() {
    let request = {
      params: {
        orderNo: this.inquiriesInquiryNo.orderNo
      }
    };
    let ret = await this.$api.getOrdersByOrderNo(request);
    if (ret) {
      this.hasOrder = true;
      this.ordererContact1 = ret.data.orderer.contact1;
      this.ordererContact2 = ret.data.orderer.contact2;
      this.lastPayAmt = ret.data.lastBalance.payAmt;
      this.lastDeliveryAmt = ret.data.lastBalance.deliveryAmt;
      this.registerYmdt = String(ret.data.registerYmdt);
    }
  }

  private inquiryHistories: InquiriesInquiryNoHistoriy[] = [];
  private async getInquiryHistories() {
    let request = {
      params: {
        inquiryNo: String(this.inquiriesInquiryNo.no)
      }
    };
    await this.$api.getInquiriesInquiryNoHistories(request).then(ret => {
      this.inquiryHistories = ret.data;
      this.inquiryHistories.reverse();
    });
  }

  private changeTemplate() {
    if(this.sumcontent.length > 0){
      if (!confirm(this.$t('INQUIRY_INQUIRY_DETAIL_CONFIRM_HAD_TEMPLATECONTENT').toString())) {

        this.$nextTick(() => {
          this.templateNo = this.oldTemplateNo;
        });
        return false;
      }
    }

    let template = this.templates.find((temp: InquiryAnswerTemplate) => this.templateNo === temp.inquiryAnswerTemplateNo);
    if (template) {
      this.sumcontent = template.inquiryAnswerTemplateContent;
      this.oldTemplateNo = this.templateNo;
    }
  }

  // private downloadFile(uploadedFilename: string, originFilename: string): void {
  //   // let url = '/object-storage?fileName=' + encodeURI(uploadedFilename) + '&serviceNo=' + this.admin.serviceNo;
  //   if (uploadedFilename.startsWith('//rlyfaazj0.toastcdn.net')) {
  //     let url = '/download/cdnImage?fileName=' + encodeURI(uploadedFilename) + '&originFilename=' + encodeURI(originFilename);
  //     window.location.assign(url);
  //   }else{
  //     const params = {fileName: encodeURI(uploadedFilename)};
  //     this.$api.getStorage({params,responseType: 'blob'}).then(res => {
  //         const blob = new window.Blob([res.data], {type: 'blob'});
  //         if ('download' in document.createElement('a')) {
  //           // 非IE下载
  //           const elink = document.createElement('a');
  //           elink.download = originFilename;
  //           elink.style.display = 'none';
  //           elink.href = URL.createObjectURL(blob);
  //           document.body.appendChild(elink);
  //           elink.click();
  //           URL.revokeObjectURL(elink.href); // 释放URL 对象
  //           document.body.removeChild(elink);
  //         } else {
  //           // IE10+下载
  //           navigator.msSaveBlob(blob, originFilename);
  //         }
  //       })
  //       .catch(error => console.log(error));
  //   }

  // }

  private downloadFile(uploadedFilename: string, originFilename: string): void {
    // let url = '/object-storage?fileName=' + encodeURI(uploadedFilename) + '&serviceNo=' + this.admin.serviceNo;
    const cdnImageUrl = ['//rlyfaazj0.toastcdn.net', '//shopby-images.cdn-nhncommerce.com'];
    if (cdnImageUrl.some(url => uploadedFilename.startsWith(url))) {
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.open('GET', uploadedFilename, true);
      xmlhttp.responseType = 'blob';
      xmlhttp.onload = function() {
        if (this.status == 200) {
          var blob = this.response;
          var a = document.createElement('a');
          a.href = window.URL.createObjectURL(blob);
          a.download = originFilename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      };
      xmlhttp.send();
    } else {
      const params = {fileName: uploadedFilename,container: 'ncp'};
      this.$api.getStorage({params,responseType: 'blob'}).then(res => {
          const blob = new window.Blob([res.data], {type: 'blob'});
          if ('download' in document.createElement('a')) {
            // 非IE下载
            const elink = document.createElement('a');
            elink.download = originFilename;
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, originFilename);
          }
        })
        .catch(error => alert(error.message));
    }

  }

  private cancel() {
    if (this.$route.query.callback) {
      $(window.opener.location).attr('href', `javascript:window.${this.$route.query.callback}();`);
    }
    window.close();
  }

  private openPop(type: string) {
    let queryString = '';
    switch (type) {
      case 'crm':
        (window as any).membersCallback = this.callback;
        queryString = this.inquiriesInquiryNo.issuer.issuerNo + '?callback=membersCallback';
        ncpPopup(`/member/popup/crm/${queryString}`, this.$t('INQUIRY_INQUIRY_DETAIL_POP_CRM'), 1100, 980);
        break;
      case 'product':
        if (this.productDetailUrl) {
          window.open(this.productDetailUrl, '_blank');
        }
        break;
      case 'order':
        (window as any).membersCallback = this.callback;
        queryString = this.inquiriesInquiryNo.orderNo + '&callback=membersCallback';
        ncpPopup(`/order/detail?orderNo=${queryString}`, '', 1100, 980);
        break;
      case 'modify':
        (window as any).membersCallback = this.modifyCallback;
        queryString = this.inquiriesInquiryNo.no + '&mallNo=' + this.mallNo + '&inquiryTypeNo=' + this.inquiriesInquiryNo.type.no + '&callback=membersCallback';
        ncpPopup(`/inquiry/popup/typeAndAdmin?inquiryNos=${queryString}`, this.$t('INQUIRY_INQUIRY_DETAIL_POP_MODIFY'), 520, 500);
        break;
    }
  }

  private callback() {
    (window as any).membersCallback = undefined;
    // this.search(1);
  }

  private modifyCallback() {
    (window as any).membersCallback = undefined;
    location.reload();
  }

  private getParseHtml (str:string){
    return jQuery.parseHTML(str)[0].textContent;
  }

  private created() {}

  private async mounted() {
    this.inquiryNo = this.$route.params.inquiryNo;
    this.mallNo = this.$route.query.mallNo;
    await this.getInquiriesInquiryNo();
    if(this.inquiriesInquiryNo.answer && this.inquiriesInquiryNo.answer.answerNo > 0){
      this.hasAnswerNo = true;
    }
    await this.getInquiryTemplates();
    if (this.templates.length > 0) {
      this.templateNo = undefined;
      this.oldTemplateNo = undefined;
    }
    await this.getProductDetailUrl();
    if (this.inquiriesInquiryNo.orderNo) {
      await this.getOrder();
    }

    await this.getInquiryHistories();
    if (this.inquiriesInquiryNo.answer) {
      if (this.inquiriesInquiryNo.answer.sms.sent && this.inquiriesInquiryNo.answer.sms.mobileNo.length > 0) {
        this.smsSend = 'SMSSEND';
      }
      if (this.inquiriesInquiryNo.answer.email.sent && this.inquiriesInquiryNo.answer.email.email.length > 0) {
        this.emailSend = 'EMAILSEND';
      }
    }

    this.sumcontent = this.inquiriesInquiryNo.answer?'<p><span style="font-size: 12px;">'+ this.inquiriesInquiryNo.answer.answerContent + '</span><br></p>':'<p><span style="font-size: 12px;"></span><br></p>';
    this.initOver = true;
  }

  private get getIssuedDateNoSec() {
    return this.inquiriesInquiryNo.issuedDateTime.substring(0, 16)
  }

  private get geAnsweredDateTimeNoSec() {
    return this.inquiriesInquiryNo.answer.answeredDateTime.substring(0, 16)
  }
}
